import PropTypes from 'prop-types';

import { getContext } from 'recompose';
export { withRouter } from 'react-router';

export let withLocation = getContext({ location: PropTypes.object });



// WEBPACK FOOTER //
// ../src/client/contextWrappers.js